import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import InfiniteScroll from "react-infinite-scroll-component";
import PublicCompetitionCard from "../Card/PublicCompetitionCard";
import {
  loadingIndicator,
  dataEndMessage,
} from "../../../../../shared/utilitiies";
import { authActions } from "../../../../../redux/actions";
import { useDispatch, useSelector } from "react-redux";

const UpcomingCompetitions = ({
  gridState,
  setGridState,
  publicCompetitions,
  flag,
  setSelectedCompetition,
  ...props
}) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  //-------Get More Centers List on Scroll
  const getMoreSpots = () => {
    const updatedGridState = { ...gridState, length: gridState.length + 10 };
    setGridState(updatedGridState);
  };

  const cities = useSelector((state) => state.LoginReducer.cities);

  return (
    <section className="text-black">
      <section className="mt-5 mb-5">
        <InfiniteScroll
          dataLength={publicCompetitions?.pageData?.length ?? 0}
          next={getMoreSpots}
          hasMore={
            publicCompetitions?.pageData?.length % 10 === 0 &&
            publicCompetitions?.pageData?.length !== 0
              ? true
              : false
          }
          loader={loadingIndicator(t)}
          endMessage={dataEndMessage(t, publicCompetitions?.pageData)}
          style={{ overflow: "hidden" }}
          scrollableTarget={"main-container"}
        >
          {publicCompetitions?.pageData?.map((data) => {
            const city = cities?.find((s) => s.id === data?.cityId);
            return (
              <PublicCompetitionCard
                key={data.id}
                city={city}
                data={data}
                flag={flag}
                setSelectedCompetition={setSelectedCompetition}
              />
            );
          })}
        </InfiniteScroll>
      </section>
    </section>
  );
};

export default UpcomingCompetitions;
